/**
 * Gallery Class
 *
 * @version 1.0.0
 * @copyright 2019 SEDA.digital GmbH & Co. KG
 */


import ClassLogger from 'ClassLogger';
import Api from './_api.js';

export default class Gallery {
    getClassName() { return 'Gallery'; }
    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true); // set second parameter to false to disable logging
        self.limit = 8;
        if ($('[data-gallery]').length === 0) return;

    }

    init() {
        let self = this;
        self.logger.log('Gallery function is running...'); // also supports .warn() and .error()

        $('[data-gallery]').each(function (index, item) {
            const $gallery = $(item);
            const $options = $gallery.data('gallery');
            const companyId = $options.company;
            const mode = $options.mode;

            self.logger.log('Gallery company id: ' + companyId);
            if (companyId === '') {
                return;
            }

            const url = 'companies/' + companyId + '/gallery';
            self.getGallery(url, $gallery, mode);

        })
    }

    getGallery(url, $gallery, mode) {
        let self = this;

        self.logger.log('Gallery API call is running...');
        self.preloader($gallery, 'show');
        // Request Data
        Api.request('GET', url, '')
            .then(function (response) {

                self.buildGallery(response, $gallery, mode, url);

            }).catch(function (exception) {
                self.logger.log('Gallery could not be loaded for url: ' + url);
            });

    }

    buildGallery(galleryData, $gallery, mode, url) {
        let self = this;
        const uniquename = $gallery.data('gallery-uniquename');
        let $gallerylist = $gallery.find('.gallery');
        const items = galleryData.data;
        items.forEach(element => {
            self.addImage(mode, element, $gallerylist, uniquename);
        });

        if (mode == 'edit') {
            // reinitialize gallerylist because of new dom items
            $gallerylist = $gallery.find('.gallery');
            self.checkLimit($gallerylist, uniquename);
            self.deleteImage($gallery, url, uniquename);
        } else {
            $('.gallery-image').modaal({
                type: 'image',
                close_text: 'Schließen',
                close_aria_label: 'Schließen (Escape Taste drücken zum schließen)',
                confirm_button_text: 'OK',
                confirm_cancel_button_text: 'Abbrechen',
                loading_content: 'Lade &hellip;'
            });
        }

        self.preloader($gallery, 'hide');

    }

    checkLimit($gallerylist, uniquename) {
        let self = this;

        $('#galleryError').remove();
        $("[data-mediaupload-uniquename='" + uniquename + "']").hide();

        if ($gallerylist.find('li').length >= self.limit) {

            $gallerylist.parent().prepend('<p class="text-center" id="galleryError"><strong>Sie haben Ihrem Upload-Limit erreicht.</strong></p>');

            self.logger.log('Gallery exceeded maximum image limit');

        } else {
            $("[data-mediaupload-uniquename='" + uniquename + "']").show();
        }
    }

    addImage(mode, element, $gallerylist, uniquename, galleryId = 'standard') {
        let self = this;

        self.checkLimit($gallerylist, uniquename);

        if (mode == 'edit') {
            $gallerylist.append('<li><div class="gallery__item"><img class="u-lazyload" data-src="' + element.thumbs.gallery_small.url + '"></div>' + '<button title="Löschen Sie dieses Bild" class="c-button--secondary c-button--outline c-gallery__delete u-extra-small-margin--top" data-image-delete="' + element.id + '"><span class="c-button__label">Löschen</span></button></li>');
        } else {
            $gallerylist.append('<li><a href=" ' + element.thumbs.gallery_large.url + ' " class="gallery-image" rel="gallery-' + galleryId + ' "><img class="u-lazyload" data-src="' + element.thumbs.gallery_small.url + '"></a></li>');
        }

    }

    deleteImage($gallery, url, uniquename) {
        let self = this;

        const $gallerylist = $gallery.find('.gallery');

        $gallery.find('[data-image-delete]').on('click', function (e) {

            e.preventDefault();

            const imageId = parseInt($(this).data('image-delete'));
            const urlDelete = url + '/' + imageId;

            self.logger.log('Gallery API call is running... deleting image: ' + imageId);

            self.preloader($gallery, 'show');
            // Request Data
            Api.request('DELETE', urlDelete, '')
                .then(function (response) {
                    self.logger.log('Delete successful', response);
                    $gallery.find("[data-image-delete='" + imageId + "']").parent().remove();
                    self.checkLimit($gallerylist, uniquename);
                    self.preloader($gallery, 'hide');

                }).catch(function (exception) {
                    self.logger.log('Image could not be deleted: ' + imageId);
                });

        })
    }

    preloader($gallery, status) {
        let self = this;
        self.logger.log('Gallery preloader triggered: ' + status);

        if (status == 'show') {
            $gallery.find('.c-preloader-overlay').css('display', 'block');
        } else if (status == 'hide') {
            $gallery.find('.c-preloader-overlay').css('display', 'none');
        }
    }
}
